import parsePhoneNumberFromString, {AsYouType, CountryCode, PhoneNumber} from 'libphonenumber-js'

interface TelephoneValidationResult
{
    valid: boolean,
    value: string
}

interface TelephoneValidationProps
{
    value: string;
}

export const validateAndMutateTelephoneFormat: ( {value}: TelephoneValidationProps ) => (TelephoneValidationResult) = ( {value}: TelephoneValidationProps ) => {
    const countryCode: CountryCode = "BE";
    const parsed: PhoneNumber | undefined = parsePhoneNumberFromString( value, countryCode );

    const valid = parsed !== undefined && parsed.isValid();
    if ( valid ) {
        let formatted = new AsYouType( countryCode ).input( value );
        return {valid: true, value: formatted};
    }

    return {valid: false, value: value};
};

